import { Base64 } from 'js-base64'

// Crypto graphic helpers

// Derive AES-GCM key via PBKDF2-SHA256
// NOTE: Slightly more secure than HKDF but Swift doesn't have a native version
// const derivePBKDF2Key = async (password: string, salt: string): Promise<CryptoKey> => {
//     const pwUtf8 = new TextEncoder().encode(password)
//     const baseKey = await crypto.subtle.importKey(
//         'raw', pwUtf8, 'PBKDF2', false, [ 'deriveKey' ]
//     )
//     return crypto.subtle.deriveKey(
//         {
//             name: 'PBKDF2',
//             salt: new TextEncoder().encode(salt),
//             iterations: 100_000,
//             hash: 'SHA-256',
//         },
//         baseKey,
//         { name: 'AES-GCM', length: 256 },
//         true,
//         [ 'encrypt', 'decrypt' ]
//     )
// }

// Derive AES-GCM key via HKDF-SHA256
const deriveHKDFKey = async (password: string, salt: string): Promise<CryptoKey> => {
    const pwUtf8 = new TextEncoder().encode(password)
    const baseKey = await crypto.subtle.importKey(
        'raw', pwUtf8, 'HKDF', false, [ 'deriveKey' ]
    )
    return crypto.subtle.deriveKey(
        {
            name: 'HKDF',
            hash: 'SHA-256',
            salt: new TextEncoder().encode(salt),
            info: new Uint8Array(),
        },
        baseKey,
        { name: 'AES-GCM', length: 256 },
        false,
        [ 'encrypt', 'decrypt' ]
    )
}

export const encrypt = async (plainText: string, password: string, salt: string): Promise<string> => {
    const key = await deriveHKDFKey(password, salt)
    const iv = crypto.getRandomValues(new Uint8Array(12)) // AES standard 12 bytes
    const ct = await crypto.subtle.encrypt(
        { name: 'AES-GCM', iv },
        key,
        new TextEncoder().encode(plainText)
    )
    const combined = new Uint8Array(iv.byteLength + ct.byteLength)
    combined.set(iv, 0)
    combined.set(new Uint8Array(ct), iv.byteLength)
    return Base64.fromUint8Array(combined, true)
}

// Decrypt a base64 encoded string using a derived Key and AES-GCM algo
export const decrypt = async (b64url: string, password: string, salt: string): Promise<string | undefined> => {
    const data = Base64.toUint8Array(b64url)
    const iv = data.slice(0, 12)
    const ct = data.slice(12)
    const key = await deriveHKDFKey(password, salt)
    try {
        const plain = await crypto.subtle.decrypt(
            { name: 'AES-GCM', iv  },
            key,
            ct
        )
        return new TextDecoder().decode(plain)
    } catch (e) {
        return Promise.resolve(undefined)
    }
}
